module.exports = __webpack_public_path__ + "static/img/AgAABXq0GNc7Y6MXAGlMy50NxFyQXLzR.39aa788.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/套装/AgAABXq0GNc7Y6MXAGlMy50NxFyQXLzR.jpeg
// module id = /ssB
// module chunks = 0